import React, { useState } from 'react';
import InsertObjectIcon from '@mui/icons-material/InsertPhoto';
import { IconButton, Popover, Tooltip } from '@mui/material';

import PlaceObjectMenu from '../PlaceObjectMenu';

const PlaceObjectButton = () => {
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLElement | null>(null);
  const popoverIsOpen = !!popoverAnchorEl;

  return (
    <>
      <Tooltip disableInteractive disableFocusListener id="place-object-tooltip" title="Place Object">
        <IconButton
          aria-label="Place Object"
          sx={{ borderRadius: 0 }}
          onClick={(event) => void setPopoverAnchorEl(event.currentTarget)}
        >
          <InsertObjectIcon />
        </IconButton>
      </Tooltip>

      <Popover
        open={popoverIsOpen}
        anchorEl={popoverAnchorEl}
        onClose={() => void setPopoverAnchorEl(null)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <PlaceObjectMenu onItemChosen={() => void setPopoverAnchorEl(null)} />
      </Popover>
    </>
  );
};

export default PlaceObjectButton;
